import React from 'react';
import { ClientType } from '@common/model/client/clientType';
import { ClientTypeIcon } from 'src/entities/client';
import { formatNumber } from '../lib';
import { coreClientStats } from '../api';
import { StatItem } from './statItem';

export const Employers = () => {
  const { data: total, isLoading } = coreClientStats.endpoints.getClientStats.useQuery({ type: ClientType.Employer });
  const { data: push } = coreClientStats.endpoints.getClientStats.useQuery({
    type: ClientType.Employer,
    notificationPlatforms: { isNotEmpty: true },
  });
  return (
    <StatItem
      isLoading={isLoading}
      label={<ClientTypeIcon type={ClientType.Employer} />}
      title="Всего нанимателей / Push"
      value={
        <>
          {formatNumber(total)} / {formatNumber(push)}
        </>
      }
    />
  );
};
